import * as Yup from 'yup';

export const MonitoredSourceSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, 'Too Short!')
		.required('Required'),
	licensedContentReadPercent: Yup.number().min(0).max(100).required('Requires a value between 0 and 100'),
	licensedContentReadDays: Yup.number().min(0).required('Requires a value of 0 or above')
});

export const QuerySchema = Yup.object().shape({
	name: Yup.string()
		.min(2, 'Too Short!')
		.required('Required'),
	query: Yup.string().required('Required')
});

export const ProfileSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, 'Too Short!')
		.required('Required')
});

export const DuplicateProfileSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, 'Too Short!')
		.required('Required')
});

export const CategorySchema = Yup.object().shape({
	name: Yup.string()
		.min(2, 'Too Short!')
		.required('Required')
});

export const SiteSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, 'Too Short!')
		.required('Required'),
	licensedContentReadPercent: Yup.number().min(0).max(100).required('Requires a value between 0 and 100'),
	licensedContentReadDays: Yup.number().min(0).required('Requires a value of 0 or above')
});

export const LoginSchema = Yup.object().shape({
	email: Yup.string()
		.email('Invalid email')
		.required('Required'),
	password: Yup.string().required('Required')
});

export const GlobalContentParsePatternSchema = Yup.object().shape({
	pattern: Yup.string().required('Required')
});

export const ContentParsePatternSchema = Yup.object().shape({
	pattern: Yup.string().required('Required')
});

export const SignUpSchema = Yup.object().shape({
	email: Yup.string()
		.email('Invalid email')
		.required('Required'),
	firstName: Yup.string()
		.min(2, 'Too Short!')
		.required('Required'),
	lastName: Yup.string()
		.min(2, 'Too Short!')
		.required('Required'),
	password: Yup.string().required('Required')
});

export const ContentExtractorTestSchema = Yup.object().shape({
	url: Yup.string()
		// either monitoredSourceId or url is required
		.when('monitoredSourceId', {
			is: monitoredSourceId => !monitoredSourceId || monitoredSourceId.length === 0,
			then: Yup.string()
				.min(5, 'Too Short!')
				.required('Required')
		})
});

export default '';
